export default __webpack_public_path__ + "static/media/trash.2b652b7d.svg";